
import React, { useRef, useEffect, useState } from 'react';
import { getInstitutions } from '../../api/institutions';
import styles from '../../styles/InstitucionesStyles/PantallaDeInstituciones.module.css';

const defaultForm = {
  nombre: '',
  institucion: '',
  codigo: '',
  direccion: '',
  telefono: '',
  email: '',
  estado: 'ACTIVO',
  // Bancaria
  banco: '',
  sucursal: '',
  tipo_cuenta: '',
  numero_cuenta: '',
  rfc: '',
  titular: '',
  telefono_bancario: '',
  email_bancario: '',
};

export default function NewCampusModal({ open, onClose, onSubmit, initialData }) {
  const [institutions, setInstitutions] = useState([]);
  // Cargar instituciones al abrir el modal
  useEffect(() => {
    if (open) {
      getInstitutions().then(setInstitutions);
    }
  }, [open]);
  const [form, setForm] = useState(initialData ? {
    nombre: initialData.nombre || '',
    institucion: initialData.institucion || '',
    codigo: initialData.codigo || '',
    direccion: initialData.direccion || '',
    telefono: initialData.telefono || '',
    email: initialData.email || '',
    estado: initialData.estado || 'ACTIVO',
    banco: initialData.banco || '',
    sucursal: initialData.sucursal || '',
    tipo_cuenta: initialData.tipo_cuenta || '',
    numero_cuenta: initialData.numero_cuenta || '',
    rfc: initialData.rfc || '',
    titular: initialData.titular || '',
    telefono_bancario: initialData.telefono_bancario || '',
    email_bancario: initialData.email_bancario || '',
  } : defaultForm);
  const [tab, setTab] = useState('general');
  const dialogRef = useRef(null);

  useEffect(() => {
    if (open) {
      if (initialData) {
        setForm({
          nombre: initialData.nombre || '',
          institucion: initialData.institucion || '',
          codigo: initialData.codigo || '',
          direccion: initialData.direccion || '',
          telefono: initialData.telefono || '',
          email: initialData.email || '',
          estado: initialData.estado || 'ACTIVO',
          banco: initialData.banco || '',
          sucursal: initialData.sucursal || '',
          tipo_cuenta: initialData.tipo_cuenta || '',
          numero_cuenta: initialData.numero_cuenta || '',
          rfc: initialData.rfc || '',
          titular: initialData.titular || '',
          telefono_bancario: initialData.telefono_bancario || '',
          email_bancario: initialData.email_bancario || '',
        });
      } else {
        setForm(defaultForm);
      }
      const first = dialogRef.current?.querySelector('input, select, textarea, button');
      first?.focus();
    }
  }, [open, initialData]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit?.(form);
    setForm(defaultForm);
  };

  // ...existing code...
  return (
    <div className={styles.institutionModalBackdrop} role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div className={styles.institutionModalContainer} role="dialog" aria-modal="true" aria-labelledby="campus-title" ref={dialogRef}>
        <div className={styles.institutionModalHeader}>
          <h2 id="campus-title" className={styles.institutionModalTitle}>Registro de Campus</h2>
        </div>
        <form className={styles.institutionModalBody} onSubmit={handleSubmit}>
          <div className={styles.institutionModalTabs}>
            <button type="button" className={styles.institutionModalTab + (tab === 'general' ? ' ' + styles.activeTab : '')} onClick={() => setTab('general')}>Información General</button>
            <button type="button" className={styles.institutionModalTab + (tab === 'bancaria' ? ' ' + styles.activeTab : '')} onClick={() => setTab('bancaria')}>Información Bancaria</button>
          </div>
          {tab === 'general' ? (
            <div className={styles.institutionModalGrid}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Nombre del Campus</label>
                <input className={styles.input} name="nombre" value={form.nombre} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Institución</label>
                <select className={styles.input} name="institucion" value={form.institucion} onChange={handleChange} required>
                  <option value="">-- Selecciona una institución --</option>
                  {institutions.map(inst => (
                    <option key={inst.id} value={inst.id}>{inst.name}</option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Código del campus</label>
                <input className={styles.input} name="codigo" value={form.codigo} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Dirección</label>
                <input className={styles.input} name="direccion" value={form.direccion} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Teléfono</label>
                <input className={styles.input} name="telefono" value={form.telefono} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Email</label>
                <input className={styles.input} type="email" name="email" value={form.email} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Estado</label>
                <select className={styles.input} name="estado" value={form.estado} onChange={handleChange}>
                  <option value="ACTIVO">ACTIVO</option>
                  <option value="INACTIVO">INACTIVO</option>
                </select>
              </div>
            </div>
          ) : (
            <div className={styles.institutionModalGrid}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Banco</label>
                <select className={styles.input} name="banco" value={form.banco} onChange={handleChange}>
                  <option value="">-- Selecciona un banco --</option>
                  <option value="banamex">Banamex</option>
                  <option value="bbva">BBVA</option>
                  <option value="santander">Santander</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Sucursal</label>
                <input className={styles.input} name="sucursal" value={form.sucursal} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Número de cuenta</label>
                <input className={styles.input} name="numero_cuenta" value={form.numero_cuenta} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Tipo de cuenta</label>
                <select className={styles.input} name="tipo_cuenta" value={form.tipo_cuenta} onChange={handleChange}>
                  <option value="">-- Selecciona el tipo de cuenta --</option>
                  <option value="ahorro">Ahorro</option>
                  <option value="cheques">Cheques</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>RFC</label>
                <input className={styles.input} name="rfc" value={form.rfc} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Titular de cuenta</label>
                <input className={styles.input} name="titular" value={form.titular} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Teléfono</label>
                <input className={styles.input} name="telefono_bancario" value={form.telefono_bancario} onChange={handleChange} />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Email</label>
                <input className={styles.input} type="email" name="email_bancario" value={form.email_bancario} onChange={handleChange} />
              </div>
            </div>
          )}
          <div className={styles.institutionModalActions}>
            <button type="submit" className={styles.primaryButton}>GUARDAR</button>
            <button type="button" className={styles.secondaryButton} onClick={onClose}>CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  );
}
